import { Chip, styled, Typography } from '@mui/material';
import { AvailabilityType } from 'api/services/availability/availability-service.schema';
import { useTranslation } from 'react-i18next';
import { getColorForAvailabilityType } from '../helpers/get-color-for-availability-type';
import { getUnavailabilityColor, isUnavailabilityType } from '../helpers/get-unavailability-color';

export const AvailabilityTypeChip = ({
  type,
  hideCompensation = false,
}: {
  type: AvailabilityType;
  hideCompensation?: boolean;
}) => {
  const { t } = useTranslation('all-platforms-common');

  let label: string;
  if (hideCompensation && isUnavailabilityType(type)) {
    label = t('availability-page.unavailability-chip.unavailable');
  } else {
    switch (type) {
      case 'available':
        label = t('availability_page.worker_available');
        break;
      case 'tentative':
        label = t('availability_page.worker_tentative');
        break;
      case 'pending':
        label = t('availability_page.worker_pending');
        break;
      case 'blocked':
        label = t('availability_page.worker_blocked');
        break;
      case 'unavailablePaid':
        label = t('availability-page.unavailability-chip.paid');
        break;
      case 'unavailableUnpaid':
        label = t('availability-page.unavailability-chip.unpaid');
        break;
      default:
        throw new Error(`Invalid availability type: ${type}`);
    }
  }

  return (
    <StyledChip
      label={
        <Typography variant="body2" fontWeight={600}>
          {label}
        </Typography>
      }
      size="small"
      sx={(theme) => ({
        backgroundColor: isUnavailabilityType(type)
          ? getUnavailabilityColor(theme)
          : getColorForAvailabilityType(type, 0.2),
      })}
    />
  );
};

const StyledChip = styled(Chip)(({ theme }) => ({
  height: 'auto',
  margin: 0,
  backgroundColor: 'transparent',
  '& .MuiChip-label': {
    whiteSpace: 'normal',
    padding: `${theme.spacing(1)} ${theme.spacing(3)}`,
  },
}));
